export default __webpack_public_path__ + "static/media/login.c6944de1.svg";